"use client"

import { toast } from "sonner"
import { colors } from "../../styles/theme"
import { useTournamentManagement } from "../../hooks/useTournamentManagement"
import { TournamentHeader } from "../../components/tournament/TournamentHeader"
import { QuickStats } from "../../components/tournament/QuickStats"
import { SearchFilters } from "../../components/tournament/SearchFilters"
import { EventList } from "../../components/tournament/EventList"
import { CategoryList } from "../../components/tournament/CategoryList"
import { TournamentContent } from "../../components/tournament/TournamentContent"
import { LoadingSpinner } from "../../components/tournament/LoadingSpinner"

export default function TournamentManagement() {
  const {
    // State
    events,
    selectedEvent,
    selectedCategory,
    categories,
    drivers,
    activeTab,
    searchTerm,
    loading,
    stats,
    filteredEvents,
    
    // Actions
    setSelectedEvent,
    setSelectedCategory,
    setActiveTab,
    setSearchTerm,
    fetchData,
    fetchCategories,
    
    // Utilities
    formatDateForDisplay,
    isEventInPast,
    getSelectedEvent,
    getSelectedCategory,
    getBracketStatusColor,
    getBracketStatusLabel,
  } = useTournamentManagement()

  const handleBracketCreated = (bracketId: string) => {
    toast.success('Tournament bracket created successfully!')
    fetchCategories(selectedEvent) // Refresh categories to update status
  }

  if (loading) {
    return <LoadingSpinner />
  }

  return (
    <div className="min-h-screen" style={{ backgroundColor: colors.background.primary }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Header */}
        <TournamentHeader onRefresh={fetchData} />

        {/* Quick Stats */}
        <QuickStats stats={stats} />

        {/* Filters */}
        <SearchFilters searchTerm={searchTerm} onSearchChange={setSearchTerm} />

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          {/* Event Selection */}
          <div className="lg:col-span-1">
            <EventList
              events={filteredEvents}
              selectedEvent={selectedEvent}
              onEventSelect={setSelectedEvent}
              formatDateForDisplay={formatDateForDisplay}
            />

            {/* Categories */}
            <CategoryList
              categories={categories}
              selectedCategory={selectedCategory}
              onCategorySelect={setSelectedCategory}
              getBracketStatusColor={getBracketStatusColor}
              getBracketStatusLabel={getBracketStatusLabel}
            />
          </div>

          {/* Main Content */}
          <div className="lg:col-span-2">
            <TournamentContent
              activeTab={activeTab}
              selectedEvent={selectedEvent}
              selectedCategory={selectedCategory}
              drivers={drivers}
              getSelectedEvent={getSelectedEvent}
              getSelectedCategory={getSelectedCategory}
              getBracketStatusColor={getBracketStatusColor}
              getBracketStatusLabel={getBracketStatusLabel}
              onTabChange={setActiveTab}
              onBracketCreated={handleBracketCreated}
            />
          </div>
        </div>
      </div>
    </div>
  )
}